import { LOAD_GROUPS, LOAD_WHATSAPP_MESSAGES } from "./actionTypes";

export const loadGroups = groups => ({
    type: LOAD_GROUPS,
    groups
});

export const loadMessages = messages => ({
    type: LOAD_WHATSAPP_MESSAGES,
    messages
});